import { render, staticRenderFns } from "./ProjectTile.vue?vue&type=template&id=684a806a&"
import script from "./ProjectTile.vue?vue&type=script&lang=js&"
export * from "./ProjectTile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\Simply\\Simply.Web.Website\\Static\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('684a806a')) {
      api.createRecord('684a806a', component.options)
    } else {
      api.reload('684a806a', component.options)
    }
    module.hot.accept("./ProjectTile.vue?vue&type=template&id=684a806a&", function () {
      api.rerender('684a806a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Js/Components/ProjectTile.vue"
export default component.exports